import de from 'date-fns/locale/de';
import es from 'date-fns/locale/es';
import fr from 'date-fns/locale/fr';
import it from 'date-fns/locale/it';
import pt from 'date-fns/locale/pt';
import ptBR from 'date-fns/locale/pt-BR';
import tr from 'date-fns/locale/tr';
import zhCN from 'date-fns/locale/zh-CN';
import zhTW from 'date-fns/locale/zh-TW';

const LOCALE_MAP = {
  de,
  es,
  fr,
  it,
  pt,
  pt_BR: ptBR,
  tr,
  zh_CN: zhCN,
  zh: zhCN,
  zh_TW: zhTW,
};

/**
 * Returns the date-fns locale object for a given Chatwoot locale code.
 * Returns null for English or unknown locales (date-fns defaults to English).
 * @param {string} [localeCode] - Chatwoot locale code (e.g., 'es', 'fr', 'pt_BR').
 * @returns {import('date-fns').Locale|null} date-fns locale object or null.
 */
export const getDateFnsLocale = localeCode => {
  if (!localeCode || localeCode === 'en') return null;
  return LOCALE_MAP[localeCode] || LOCALE_MAP[localeCode.split('_')[0]] || null;
};
